import React, { useRef, useState, useEffect, useCallback } from "react";

/**
 * PayScroller — pista horizontal con flechas.
 *
 * Las flechas solo aparecen si el contenido realmente desborda, y se
 * deshabilitan al llegar a cada extremo. En táctil el swipe funciona
 * igual; las flechas son para mouse y para pantallas sin gesto.
 *
 * Requiere pay-mdl.css
 */
export default function PayScroller({ children }) {
   const trackRef = useRef(null);
   const [overflow, setOverflow] = useState(false);
   const [atStart, setAtStart] = useState(true);
   const [atEnd, setAtEnd] = useState(false);

   const update = useCallback(() => {
      const el = trackRef.current;
      if (!el) return;
      const max = el.scrollWidth - el.clientWidth;
      setOverflow(max > 4);
      setAtStart(el.scrollLeft <= 2);
      setAtEnd(el.scrollLeft >= max - 2);
   }, []);

   useEffect(() => {
      const el = trackRef.current;
      if (!el) return;
      update();
      el.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);

      // Si las tarjetas cargan después (imágenes, datos), recalcula.
      const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(update) : null;
      if (ro) ro.observe(el);

      return () => {
         el.removeEventListener("scroll", update);
         window.removeEventListener("resize", update);
         if (ro) ro.disconnect();
      };
   }, [update, children]);

   const nudge = (dir) => {
      const el = trackRef.current;
      if (!el) return;
      el.scrollBy({ left: dir * Math.round(el.clientWidth * 0.8), behavior: "smooth" });
   };

   return (
      <div className={`pay-scroller ${overflow ? "has-overflow" : ""}`}>
         {overflow ? (
            <button
               type="button"
               className="pay-scroller-arrow pay-scroller-arrow--prev"
               aria-label="Anterior"
               disabled={atStart}
               onClick={() => nudge(-1)}
            >
               <i className="uil uil-angle-left-b" />
            </button>
         ) : null}

         <div className="pay-scroller-track" ref={trackRef}>
            {children}
         </div>

         {overflow ? (
            <button
               type="button"
               className="pay-scroller-arrow pay-scroller-arrow--next"
               aria-label="Siguiente"
               disabled={atEnd}
               onClick={() => nudge(1)}
            >
               <i className="uil uil-angle-right-b" />
            </button>
         ) : null}
      </div>
   );
}